export enum DNTCaptchaLanguage {
  Persian,
  English,
}
